/**
 * The open questions Wingo asks (XC-PRICE-GUARD U3b §5): `GET /api/v1/business-profile/questions`
 * through the Business Profile's one client (`businessProfileClient`: the tenant is always the
 * JWT's). The reply is parsed with `OpenQuestionsSchema` before the Inbox sees it; a reply that
 * fails is refused whole (`OpenQuestionsContractError`), never drawn in part.
 */

import { OpenQuestionsSchema, type OpenQuestions } from '@/types/businessProfile/openQuestions';

import { businessProfileApi } from './businessProfileClient';

export const OPEN_QUESTIONS_PATH = '/api/v1/business-profile/questions';

/** The reply did not hold to the contract: nothing of it is shown. */
export class OpenQuestionsContractError extends Error {
  constructor(public readonly issues: string[]) {
    super(`open questions failed their contract: ${issues.join('; ')}`);
    this.name = 'OpenQuestionsContractError';
  }
}

export async function fetchOpenQuestions(): Promise<OpenQuestions> {
  const { data } = await businessProfileApi.get<unknown>(OPEN_QUESTIONS_PATH);
  const parsed = OpenQuestionsSchema.safeParse(data);
  if (!parsed.success) {
    throw new OpenQuestionsContractError(
      parsed.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`),
    );
  }
  return parsed.data;
}
